
import { useNavigate } from 'react-router-dom';

interface TopNavigationProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  rightAction?: React.ReactNode;
}

export default function TopNavigation({ 
  title, 
  showBack = false, 
  onBack,
  rightAction 
}: TopNavigationProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-white border-b border-gray-100 z-40">
      <div className="flex items-center justify-between px-4 py-4 pt-12">
        <div className="flex items-center">
          {showBack && (
            <button
              onClick={handleBack}
              className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-3 hover:bg-gray-200 transition-colors duration-200"
            >
              <i className="ri-arrow-right-line text-gray-600 text-lg"></i>
            </button>
          )}
          <h1 className="text-xl font-bold text-[#333333]">{title}</h1>
        </div>
        
        {rightAction && (
          <div>{rightAction}</div>
        )}
      </div>
    </div>
  );
}
